import { Injectable, OnDestroy } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AgGridRequestService } from "src/app/services/ag-grid-request.service";
import { HeaderService } from "src/app/components/header/header.service";
import { AuthService } from "src/app/services/auth.service";
import { takeUntil } from "rxjs/operators";
import {
  ItemMaster,
  LocationHistoryReasonTypeAhead,
  WarehouseList,
  WarehouseLocations,
  WarehouseSideBar,
  WhLocationMaster,
} from "src/app/models/warehouse.model";
import {
  GridApi,
  IServerSideDatasource,
  IServerSideGetRowsParams,
} from "@ag-grid-community/core";
import { Observable, Subject } from "rxjs";
@Injectable({
  providedIn: "root",
})
export class LogisticService implements OnDestroy {
  private destroy$ = new Subject<void>();
  gridApi: GridApi;
  gridApiH: GridApi;
  public objdata: WarehouseSideBar;
  public deleteLsummary: WarehouseSideBar;
  private headers = new HttpHeaders({ "Content-Type": "application/json" });
  options = { headers: this.headers };
  logisticUrl = "api/logistics";

  constructor(
    private http: HttpClient,
    private agGridRequestService: AgGridRequestService
  ) {}
  GetWHLocationList(body, columnDefs, globalSearch?) {
    const payload = this.agGridRequestService.transformAgGridRequest(
      body,
      columnDefs,
      globalSearch
    );
    return this.http.post(
      `/${this.logisticUrl}/GetWhLocationList`,
      payload,
      this.options
    );
  }

  GetAllHistoryList(body, columnDefs,globalSearch?,ProductId?,LocationId?) {
    var filters={};
    if(ProductId){
      filters = {
        ItemId: {
          filterType: "number",
          type: "equals",
          filter: ProductId
        }
      }
    }
    if(LocationId){
      filters = {
        LocationId: {
          filterType: "number",
          type: "equals",
          filter: LocationId
        }
      }
    }
    const payload = this.agGridRequestService.transformAgGridRequest(
      body,
      columnDefs,
      globalSearch,
      filters
    );
    return this.http.post(
      `/${this.logisticUrl}/GetAllLocationItemsHistory`,
      payload,
      this.options
    );
  }

  GetWHLocationSummeryByIds(body, globalSearch?) {
    return this.http.post(
      `/${this.logisticUrl}/GetWhLocatrionSummeryByLocationID`,
      body,
      this.options
    );
  }

  GetWHLocationHistoryByIds(body, globalSearch?) {
    return this.http.post(
      `/${this.logisticUrl}/GetWhLocatrionHistoryByLocationID`,
      body,
      this.options
    );
  }

  public GetItemMasterAuto(request: string): Observable<ItemMaster[]> {
    return this.http.get<ItemMaster[]>(
      `/${this.logisticUrl}/GetItemMasterAutocomplete?Qry=${request}`
    );
  }

  public GetWhLocationAuto(request: string): Observable<WhLocationMaster[]> {
    return this.http.get<WhLocationMaster[]>(
      `/${this.logisticUrl}/GetWhLocationAutocomplete?Qry=${request}`
    );
  }

  GetAllWareHouseList() {
    return this.http.post(`/${this.logisticUrl}/GetWhHouseList`, this.options);
  }

  GetLocationByWId(warehouseId) {
    return this.http.get(
      `/${this.logisticUrl}/GetLocationByWId?WarehouseId=${warehouseId}`)
  }
  
  public GetWareHouseViewList() {
    return this.http.post(
      `/${this.logisticUrl}/GetWhHouseViewList`,
      this.options
    );
  }

  public SaveWarehouse(warehouse: WarehouseList) {
    const data = JSON.stringify(warehouse);
    return this.http.post(
      `/${this.logisticUrl}/SaveWhHouse`,
      data,
      this.options
    );
  }
  public registerMember(whlocation: WarehouseLocations) {
    const data = JSON.stringify(whlocation);
    return this.http.post(
      `/${this.logisticUrl}/SaveWhLocation`,
      data,
      this.options
    );
  }

  public SaveLocationSummery(whlocation: WarehouseLocations) {
    const data = JSON.stringify(whlocation);
    return this.http.post(
      `/${this.logisticUrl}/SaveLocationSummery`,
      data,
      this.options
    );
  }

  public DeleteWhLocation(whLocationId: any) {
    var req = {
      locationId: whLocationId,
    };

    const data = JSON.stringify(req);
    return this.http.post(
      `/${this.logisticUrl}/RemoveWhLocation`,
      data,
      this.options
    );
  }

  public DeleteWareHouse(whLocationId: any) {
    var req = {
      WarehouseId: whLocationId,
    };

    const data = JSON.stringify(req);
    return this.http.post(
      `/${this.logisticUrl}/DeleteWareHouse`,
      data,
      this.options
    );
  }

  public typeaheadLocationHistoryReason(
    request: string
  ): Observable<LocationHistoryReasonTypeAhead[]> {
    return this.http.get<LocationHistoryReasonTypeAhead[]>(
      `/${this.logisticUrl}/TypeaheadLocationHistoryReason?Qry=${request}`
    );
  }

  public WhLocationFBMEnabled(whdata: any, value: any) {
    var req = {
      locationId: whdata.locationid,
      warehouseId: whdata.WarehouseId,
      FBMEnabled: value,
    };
    const data = JSON.stringify(req);
    return this.http.post(
      `/${this.logisticUrl}/WhLocationFBMEnabled`,
      data,
      this.options
    );
  }

  public FBMEnableWhLocation(whdata: any) {
    var req = {
      locationId: whdata.locationid,
      warehouseId: whdata.WarehouseId,
    };

    const data = JSON.stringify(req);
    return this.http.post(
      `/${this.logisticUrl}/FBMEnabled`,
      data,
      this.options
    );
  }

  public GetWhHouseByWhId(whid) {
    var req = {
      WarehouseId: whid,
    };
    const data = JSON.stringify(req);
    return this.http.post(
      `/${this.logisticUrl}/GetWhHouseByWhId`,
      data,
      this.options
    );
  }
  public DeleteWhLocationSummery(obj: any) {
    const data = JSON.stringify(obj);
    return this.http.post(
      `/${this.logisticUrl}/DeleteLocationSummery`,
      data,
      this.options
    );
  }
  // public DeleteWhLocationSummery(whLocationSummseyId: any) {
  //   var req = {
  //     LocationSummaryId: whLocationSummseyId,
  //   };

  //   const data = JSON.stringify(req);
  //   return this.http.post(
  //     `/${this.logisticUrl}/DeleteLocationSummery`,
  //     data,
  //     this.options
  //   );
  // }

  public onTriggerSideber(data) {
    this.objdata = data;;
    this.gridApi?.setGridOption("serverSideDatasource", this.dataSource);
    this.gridApiH?.setGridOption("serverSideDatasource", this.dataSourceH);
  }

  dataSource: IServerSideDatasource = {
    getRows: (params: IServerSideGetRowsParams) => {
      var data = {
        WarehouseId: this.objdata.WarehouseId,
        locationid: this.objdata.locationid,
      };

      this.GetWHLocationSummeryByIds(data, "")
        .pipe(takeUntil(this.destroy$))
        .subscribe((response: any) => {
          if (response) {
            if (!response.length) {
              this.gridApi.showNoRowsOverlay();
            } else {
              this.gridApi.hideOverlay();
            }
            params.success({
              rowData: response,
              rowCount: response.length,
            });
          }
        });
    },
  };

  dataSourceH: IServerSideDatasource = {
    getRows: (params: IServerSideGetRowsParams) => {
      var data = {
        WarehouseId: this.objdata.WarehouseId,
        locationid: this.objdata.locationid,
      };

      this.GetWHLocationHistoryByIds(data, "")
        .pipe(takeUntil(this.destroy$))
        .subscribe((response: any) => {
          if (response) {
            if (!response.length) {
              this.gridApiH.showNoRowsOverlay();
            } else {
              this.gridApiH.hideOverlay();
            }
            params.success({
              rowData: response,
              rowCount: response.length,
            });
          }
        });
    },
  };

  GetWhLocationListforproduct(payload) {
    return this.http.post(
      `/${this.logisticUrl}/GetWhLocationListforproduct`,
      payload,
      this.options
    );
  }

  GetWhLocationDetail(locationId) {
    return this.http.post(
   `/${this.logisticUrl}/GetWhLocationDetail`,
   locationId,
   this.options
 );
}
ProductWarehouseSummary(itemId){
 return this.http.get(
   `/${this.logisticUrl}/ProductWarehouseSummary?ItemId=${itemId}`)
}

 ExportProductInventory() {
   return this.http.get(`/${this.logisticUrl}/ExportProductInventory`, {
     headers: this.headers,
     observe: "response",
     responseType: "blob",
   });
 }

  getAllLocationItemsHistoryExport(filters, columns, globalSearch,isExport) {
    const body = {
      filterModel: filters,
    };
    const payload = this.agGridRequestService.transformAgGridRequest(
      body,
      columns,
      globalSearch,
      null,
      null,
      isExport
    );
    return this.http.post(`/${this.logisticUrl}/GetAllLocationItemsHistoryExport`, payload, {
      headers: this.headers,
      observe: "response",
      responseType: "blob",
    });
  }

  ReplanishWarehouseSummary(data){
    return this.http.get(
      `/${this.logisticUrl}/ProductWarehouseSummaryBySkuId?AccountSkuId=${data}`)
  }

  ProductWarehouseDetails(itemId){
    return this.http.get(
      `/${this.logisticUrl}/ProductWarehouseDetails?ItemId=${itemId}`)
   }

   GetWHLocationSummery(body, columnDefs, globalSearch?) {
    const payload = this.agGridRequestService.transformAgGridRequest(
      body,
      columnDefs,
      globalSearch
    );
    return this.http.post(
      `/${this.logisticUrl}/GetWhLocatrionSummery`,
      payload,
      this.options
    );
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
